import React from "react"

function FormCard() {
    return (
        < div class="card shadow-light-lg lift lift-lg" >

            {/* Image */}
            < img src="assets/img/photos/contact_us.png" alt="..." class="card-img-top" />

            {/* Shape */}
            < div class="position-relative" >
                <div class="shape shape-bottom shape-fluid-x svg-shim text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor" />
                    </svg>
                </div>
            </div >

            {/* Body */}
            < div class="card-body" >

                {/* Form */}
                < form action="https://formsubmit.co/e41dfeca614cec879b71d46dd20e328e" method="post">
                    <div class="form-label-group">
                        <input type="text" class="form-control form-control-flush" id="cardName" placeholder="Name" name="name" pattern="^[a-zA-Z0-9.- ]+$" title="Enter a valid name" required />
                        <label for="cardName">Name</label>
                    </div>
                    <div class="form-label-group">
                        <input type="email" class="form-control form-control-flush" id="cardEmail" placeholder="Email" name="email" required />
                        <label for="cardEmail">Email</label>
                    </div>
                    <div class="mt-6">
                        <button class="btn btn-block btn-success lift" type="submit">
                            Free Consultation
                          </button>
                         <input type="hidden" name="_next" value={window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + "/thankyou"}/>
                    </div>
                    <input type="hidden" name="b_fdd33b81d0328dbbd13864c1b_feaf610dc0" value=""></input>
                </form >

            </div >

        </div >
    )
}

export default FormCard
